import { render } from "./ViewResultCardHeader.vue?vue&type=template&id=2f79ff83&ts=true"
import script from "./ViewResultCardHeader.vue?vue&type=script&lang=ts"
export * from "./ViewResultCardHeader.vue?vue&type=script&lang=ts"

import "./ViewResultCardHeader.vue?vue&type=style&index=0&id=2f79ff83&lang=scss"

import exportComponent from "/builds/atx/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__